import { Icon } from '@cfa/react-components';

const SpeedSvg = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    strokeLinecap="round"
    strokeLinejoin="round"
    className="icon icon-tabler icons-tabler-outline icon-tabler-brand-speedtest"
  >
    <path stroke="none" d="M0 0h24v24H0z" fill="none" />
    <path d="M5.636 19.364a9 9 0 1 1 12.728 0" />
    <path d="M16 9l-4 4" />
  </svg>
);

const SpeedIcon = () => <Icon icon={SpeedSvg} />;

export default SpeedIcon;
